<template lang="pug">
div
  div.pa-2
    div.d-flex.align-center
      v-tooltip(top color="black" content-class="black tooltip-top-arrow")
        template(#activator="{ on, attrs }")
          div(v-bind="attrs" v-on="on")
            div.text-xs.font-medium.neutral700--text.clickable.ellipsis-text-1 {{ panel.name }}
        div(style="max-width: 30vw; min-width: 60px;")
          .text-sm.text-white {{ panel.name }}
      v-tooltip(top color="black" content-class="black tooltip-top-arrow")
        template(#activator="{ on, attrs }")
          div(v-bind="attrs" v-on="on")
            yz-badge.clickable.ml-2(color="neutral-200" border-color="neutral-300" text-color="neutral-500" border size="sm")
              span Panel
              yz-icon.ml-1(size="12" color="neutral-500") $yzi-info-circle
        div(style="max-width: 30vw; min-width: 60px;")
          .yz-heading-9.text-white Remarks
          .text-regular-body-sm.text-white {{ panel.remarks || '-' }}
          template(v-if="panel.staffId")
            .yz-heading-9.text-white Staff
            .text-regular-body-sm.text-white {{ panel.staffId }}


    div.d-flex.align-center.mt-2
      y-button(label="Set amount" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="showRecordPaymentDialog = true")
      v-spacer
      y-button(outlined height="24" color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-trash-03" icon-color="danger500" icon-size="16" unset-min-width size="xxs" button-class="px-1" @click="showConfirmationDialog = true")

  .dialogs
    record-payment-dialog(v-if="showRecordPaymentDialog" :open.sync="showRecordPaymentDialog" :panel="panel" @updated="updateTransaction")
    y-dialog(v-if="showConfirmationDialog" v-model="showConfirmationDialog" max-width=480 persistent fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-md.font-medium.mb-4 Delete this payment?
          .text-sm {{ $t('click_confirm_to_proceed') }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          y-button(@click="showConfirmationDialog = false" size="sm" :label="$t('cancel')" underline)
          y-button(@click="deleteDefault" :loading="isDeleting" color="danger" :label="$t('confirm')" size="sm" dark)
  
</template>

<script>
import { mapGetters } from 'vuex'
import RecordPaymentDialog from '@/components/clinic/checkout/RecordPaymentDialog.vue'

export default {
  components: { RecordPaymentDialog },
  props: {
    panel: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isDeleting: false,
    showRecordPaymentDialog: false,
    showConfirmationDialog: false,
  }),
  computed: {
    ...mapGetters({
      isHq: 'hq/getIsHq'
    })
  },
  methods: {
    deleteDefault () {
      this.$emit('deleted')
    },
    updateTransaction () {
      this.$emit('updated')
    },
  }
}
</script>

<style lang="scss" scoped>
.stack-documents {
  margin-left: -6px;
}
</style>